import axios from 'axios';

export const shouldUserSeeCaseInAmendment = async (caseUuid: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/in-amendment-for-user`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
